import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ProductLink } from '@idealsupply/products-api-angular-client';
import { FileButtonComponent } from 'common-ui';

@Component({
  selector: 'ideal-product-links-view',
  imports: [FileButtonComponent],
  templateUrl: './product-links-view.component.html',
  styleUrl: './product-links-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductLinksViewComponent {
  public readonly links = input.required<ProductLink[]>();
}
